/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { acceptInviteResponseV4Schema } from './acceptInviteResponseV4Schema'

export const acceptInviteResponseV4ApiResponseObjectV4Schema = z
  .object({
    ok: z.boolean().default(false),
    errorMsg: z.string().nullish(),
    redirectAction: z.unknown().nullish(),
    result: acceptInviteResponseV4Schema.describe(
      'Result of redeeming an invitation: the account was created and logged straight in.'
    ),
  })
  .describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )
